import React, { Component } from 'react';
import './App.css';
import Search from './Search';
import SearchResults from './SearchResults';
import 'whatwg-fetch';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      context: props.context,
      data: [],
      searchString: ""
    };

    this.handleResultChange = this.handleResultChange.bind(this);
    this.closeOverlay = this.closeOverlay.bind(this);
  }

  closeOverlay() {
    let body = this.state.context;
    let activeClose = this.state.context.find('.active .overlay-close');
    let activeContentItem = this.state.context.find('.active .overlay-content-item a');
    let searchAnchor = this.state.context.find('.search-menu-item');
    let popularItem = this.state.context.find('.popular-item a');
    let searchInput = this.state.context.find('.search-input');
    body.css({"overflow-y": "auto", "position": "initial"});
    activeClose.attr('tabIndex', '-1');
    activeContentItem.attr('tabIndex', '-1');
    searchAnchor.removeClass('active');
    popularItem.attr('tabIndex', '-1');
    searchInput.attr('tabIndex', '-1');
  }

  handleResultChange(data, searchString) {
    this.setState({
      data,
      searchString
    });
  }

  render() {
    return (
      <div className="App" tabIndex="-1">
        <div className="overlay overlay--top overlay--search" tabIndex="-1">
          <button
            className="close-icon close-search red overlay-close"
            tabIndex="-1"
            onClick={this.closeOverlay}
          >
            <span className="visually-hidden">Close</span>
          </button>
          <Search onSearch={this.handleResultChange} />
          <SearchResults
            results={this.state.data}
            searchString={this.state.searchString}
          />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js